// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ModifyStopLimitOrder } from '../order-modify/ModifyStopLimitOrder';
import { OrderTypeBase } from './OrderTypeBase';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { StopLimitOrderEdit } from '../order-edit/StopLimitOrderEdit';
export class StopLimitOrderType extends OrderTypeBase {
    constructor() {
        super(StopLimitOrderEdit, ModifyStopLimitOrder);
    }
    id() {
        return OrderType.StopLimit;
    }
    localizationKey() {
        return 'Stop Limit';
    }
}
